import Presentation from "./presentation";

const component = ( {
	fetchMore,
	history,
	isDepleted,
	isLoading
} ) => {
	return (
		<Presentation
			fetchMore  = { fetchMore }
			history    = { history }
			isDepleted = { isDepleted }
			isLoading  = { isLoading }
		/>
	);
};

export default component;
